import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const webhookLogEntity: Entity = {
  model: model,
  repository: repository,
}

export default webhookLogEntity
